export var DomainStoreType;
(function (DomainStoreType) {
    DomainStoreType["BrowserLocal"] = "BrowserLocal";
    DomainStoreType["BrowserSession"] = "BrowserSession";
    DomainStoreType["Memory"] = "Memory";
})(DomainStoreType || (DomainStoreType = {}));
export const isPersistedDomainStore = (store) => {
    return store.type === DomainStoreType.BrowserLocal || store.type === DomainStoreType.BrowserSession;
};
//# sourceMappingURL=domain-store.js.map